import {
  ButtonGroup,
  CheckList,
  CircularButtonGroup,
  ContextualForm,
  SignatureCanvas,
  TimeRangePicker,
} from '.';
import { AddToAppleWallet } from './AddToAppleWallet';
import { Consent, TermsAndConditions, PatientAuthorization } from './Consent';
import { InputEmailModal, InputPhoneModal } from './InputModal';
import { BaseComponent, Components } from './types';

export const getComponentByName = (name?: Components): BaseComponent | undefined => {
  if (name === 'ButtonGroup') return ButtonGroup;
  if (name === 'CheckList') return CheckList;
  if (name === 'TimeRangePicker') return TimeRangePicker;
  if (name === 'ContextualForm') return ContextualForm;
  if (name === 'SignatureCanvas') return SignatureCanvas;
  if (name === 'AddToAppleWallet') return AddToAppleWallet;
  if (name === 'Consent') return Consent;
  if (name === 'CircularButtonGroup') return CircularButtonGroup;
  if (name === 'TermsAndConditions') return TermsAndConditions;
  if (name === 'InputEmailModal') return InputEmailModal;
  if (name === 'InputPhoneModal') return InputPhoneModal;
  if (name === 'PatientAuthorization') return PatientAuthorization;
  else return undefined;
};
